export default "__VITE_ASSET__7OTWXvbM__"